import { AsyncPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import {
  KeyboardFocusModule,
  OutletModule,
  OutletRefModule,
  PageLayoutModule,
  PageSlotModule,
} from '@spartacus/storefront';

import { DpStorefrontComponent } from './storefront.component';
import { DpGlobalMessageModule } from '@app-modules/global-message';

@NgModule({
  declarations: [DpStorefrontComponent],
  exports: [DpStorefrontComponent],
  imports: [
    KeyboardFocusModule,
    AsyncPipe,
    PageLayoutModule,
    PageSlotModule,
    OutletRefModule,
    OutletModule,
    RouterOutlet,
    DpGlobalMessageModule,
  ],
})
export class DpStorefrontModule {}
